'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


// Constants


var _formSubReducerWrapper = require('../../../components/form/formSubReducerWrapper');

var _formSubReducerWrapper2 = _interopRequireDefault(_formSubReducerWrapper);

var _paymentConstants = require('./paymentConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentFormReducer = function paymentFormReducer(state, action) {
    switch (action.type) {
        case _paymentConstants.PAYMENT_CARD_CLEAR:
            return _extends({}, state, {
                number: { value: undefined },
                expiry: { value: undefined },
                cvc: { value: undefined },
                cardBrand: { value: undefined },
                postcode: { value: undefined },
                cardName: { value: undefined },
                cardPrefilled: { value: false }
            });
        default:
            return state;
    }
};

exports.default = (0, _formSubReducerWrapper2.default)(paymentFormReducer, _paymentConstants.PAYMENT_FORM_NAME);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/paymentFormReducer.js
// module id = 2062
// module chunks = 0